export const allAsync = async (source, predicate) => {
    for await (const item of source) {
        if (await predicate(item) === false) {
            return false;
        }
    }
    return true;
};
